/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".layer-controls[_ngcontent-%COMP%]{position:absolute;right:.5em;top:6.5em}.layer-controls[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:100%;width:100%}.map-bottom-left[_ngcontent-%COMP%]{position:absolute;bottom:10px;left:200px}.map-bottom-right[_ngcontent-%COMP%]{position:absolute;bottom:10px;right:10px}#mapBdryInfo[_ngcontent-%COMP%]{font-size:10px;text-align:right}\n/*# sourceMappingURL=main-data-map.component.css.map*/"];
export { styles as styles };
